import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAccionesSearch, setAccionesFilterArea, setAccionesFilterTalento,
  clearAccionesFilters, openAccionMultiplesModal,
} from "../../../store/reducers/fortalezas/fortalezasPlantel.reducer";
import SearchInput from "../../UI/SearchInput";
import Select2 from "../../UI/Select2";
import { getAreasSelectoresPlantelService } from "../../../services/fortalezas/fortalezasPlantel.service";
import { getTalentosSelectoresPlantelService } from "../../../services/planteles/talentosPlantel.service";
import { useParams } from "react-router-dom";

const AccionesHeaderPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { accionesSearch, accionesFilterArea, accionesFilterTalento } = useSelector((state) => state.fortalezasPlantel);

  const fetchAreas = async (searchTerm) => {
    const response = await getAreasSelectoresPlantelService(plantelId, searchTerm);
    return response.map((item) => ({ id: item.id, label: item.label || item.area }));
  };

  const fetchTalentos = async (searchTerm) => {
    const response = await getTalentosSelectoresPlantelService(plantelId, searchTerm);
    return response.map((item) => ({ id: item.id, label: item.label }));
  };

  const hasFilters = accionesSearch || accionesFilterArea || accionesFilterTalento;

  return (
    <div className="mb-3">
      <div className="row g-2 align-items-center">
        <div className="col-12 col-md-auto">
          <h5 className="mb-0 fw-semibold d-flex align-items-center gap-2">
            <Icon icon="mdi:lightbulb-outline" width="22" /> Acciones de Desarrollo
          </h5>
        </div>
        <div className="col-12 col-md">
          <div className="d-flex flex-column gap-2">
            <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end">
              <SearchInput value={accionesSearch} onChange={(v) => dispatch(setAccionesSearch(v))} placeholder="Buscar acciones..." minChars={3} className="flex-grow-1" />
              <button onClick={() => dispatch(openAccionMultiplesModal())} className="btn btn-primary d-flex align-items-center justify-content-center gap-2 radius-8" style={{ height: "44px", minWidth: "160px" }}>
                <Icon icon="mdi:plus-box-multiple" width="20" />
                <span className="d-none d-sm-inline fw-medium">Crear múltiples</span>
                <span className="d-inline d-sm-none fw-medium">Múltiples</span>
              </button>
            </div>
            <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end align-items-sm-center">
              <div style={{ minWidth: "200px", maxWidth: "280px" }}>
                <Select2 value={accionesFilterArea} onChange={(v) => dispatch(setAccionesFilterArea(v || ""))} fetchOptions={fetchAreas} placeholder="Filtrar por área..." />
              </div>
              <div style={{ minWidth: "200px", maxWidth: "280px" }}>
                <Select2 value={accionesFilterTalento} onChange={(v) => dispatch(setAccionesFilterTalento(v || ""))} fetchOptions={fetchTalentos} placeholder="Filtrar por talento..." />
              </div>
              {hasFilters && (
                <button onClick={() => dispatch(clearAccionesFilters())} className="btn btn-outline-secondary d-flex align-items-center gap-2" style={{ height: "44px" }}>
                  <Icon icon="mdi:filter-remove-outline" width="18" /><span className="d-none d-sm-inline">Limpiar filtros</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccionesHeaderPlantel;
